import "@/App.css";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Toaster } from "sonner";
import { CrmProvider } from "@/context/CrmContext";
import { AppShell } from "@/components/AppShell";
import KanbanPage from "@/pages/KanbanPage";
import TodayPage from "@/pages/TodayPage";
import CompaniesPage from "@/pages/CompaniesPage";
import CompanyPage from "@/pages/CompanyPage";
import StatsPage from "@/pages/StatsPage";

function App() {
  return <CrmProvider><BrowserRouter><Routes><Route element={<AppShell />}><Route path="/" element={<KanbanPage />} /><Route path="/dzisiaj" element={<TodayPage />} /><Route path="/firmy" element={<CompaniesPage />} /><Route path="/firmy/:id" element={<CompanyPage />} /><Route path="/statystyki" element={<StatsPage />} /><Route path="*" element={<Navigate to="/" replace />} /></Route></Routes></BrowserRouter><Toaster position="bottom-right" richColors={false} closeButton /></CrmProvider>;
}

export default App;
